import ContactPage from "../pages/ContactPage";

const Contact = () => {
    return (
        <ContactPage />
    )
};

export default Contact; 
